import { getCLS, getLCP, getFID } from 'web-vitals';
import { deepMerge, encode, toFuzzy } from '@klook/logquery';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var conf = {
  url: 'https://t145.test.klook.io/v2/frontlogsrv/log/web',
  platform: 'desktop',
  queueInterval: 5000,
  queueSize: 15,
  getPageData: function getPageData() {
    return {};
  },
  getPageUrl: function getPageUrl() {
    return window.location.href.split('?')[0];
  },
  extraMsg: {// tag: 'default'
  }
};

function onPageLoaded(fn) {
  if (document.readyState === 'complete') {
    fn();
  } else {
    window.addEventListener('load', fn, false);
  }
}
function getDomain() {
  return document.domain || location.hostname;
}
function isBrowser() {
  return typeof document === 'object' && typeof window === 'object';
}
/**
 * 获取数据的字节长度
 * Ref: https://stackoverflow.com/questions/5515869/string-length-in-bytes-in-javascript
 * @param data 数据
 */

function getContentLength(data) {
  var m = encodeURIComponent(data).match(/%[89ABab]/g);
  return data.length + (m ? m.length : 0);
}

var _excluded = ["timestamp", "message", "userId", "requestId", "logVersion", "codeVersion"];
/**
 * encode数据，同 logQuery
 * @param logObj
 */

function transform(logObj) {
  var logObjCopy = deepMerge({}, logObj);
  logObjCopy.logVersion = logObjCopy.hasOwnProperty('logVersion') ? logObjCopy.logVersion : 1;
  logObjCopy.type === 5 && (logObjCopy.message.system = 'optimus');
  logObjCopy.message = logObjCopy.type === 0 ? encode(toFuzzy(logObjCopy.message)) : encode(JSON.stringify(logObjCopy.message));

  var timestamp = logObjCopy.timestamp,
      message = logObjCopy.message,
      userId = logObjCopy.userId,
      requestId = logObjCopy.requestId,
      logVersion = logObjCopy.logVersion,
      codeVersion = logObjCopy.codeVersion,
      others = _objectWithoutPropertiesLoose(logObjCopy, _excluded);

  var newLogObj = _extends({
    time: timestamp,
    msg: message,
    log_ver: logVersion,
    type: 4
  }, others);

  userId && (newLogObj.uid = userId);
  requestId && (newLogObj.req_id = requestId);
  codeVersion && (newLogObj.code_ver = codeVersion);
  return newLogObj;
}
/**
 * beacon fetch 发送数据
 * @param url
 * @param data
 */


function fetch(url, data) {
  if (!data) return;
  var reportData = JSON.stringify(data);

  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([reportData], {
      type: 'application/json'
    }));
    return;
  }

  if (window.fetch) {
    window.fetch(url, {
      headers: {
        'content-type': 'application/json'
      },
      body: reportData,
      method: "POST",
      credentials: "omit"
    });
  }
}
/**
 * 格式化report数据
 * @param data
 */


function formatReportData(data) {
  return {
    logs: data
  };
}

var queueLogData = [];
var queueTimer = undefined;
/**
 * 上报数据，优先 beacon、fetch 不支持不上报数据
 * @param options
 * @param logObj
 * @param useQueue
 */

function report (options, logObj, useQueue) {
  if (useQueue === void 0) {
    useQueue = false;
  }

  if (!isBrowser()) return;

  if (options.debug) {
    var _logObj$message;

    console.log("--client-report--[" + ((_logObj$message = logObj.message) === null || _logObj$message === void 0 ? void 0 : _logObj$message._logger_name_) + "]", logObj);
  }

  var realLogObj = transform(logObj); // 合并上报

  if (useQueue) {
    clearTimeout(queueTimer);
    queueLogData.push(realLogObj);

    if (queueLogData.length >= options.queueSize) {
      fetch(options.url, formatReportData(queueLogData)); // flush

      queueLogData.length = 0;
      return;
    }

    queueTimer = window.setTimeout(function () {
      fetch(options.url, formatReportData(queueLogData));
      queueLogData.length = 0;
    }, options.queueInterval);
    return;
  } // 立即上报


  fetch(options.url, formatReportData([realLogObj]));
}

// 强制开启debug

var DEBUG_UA = 'SeoValidate';
var DEBUG_STORAGE = '__clientReport:debug';

var Report = /*#__PURE__*/function () {
  function Report(options) {
    var forceDebug = window.navigator.userAgent.includes(DEBUG_UA) || !!window.localStorage.getItem(DEBUG_STORAGE);
    this.options = Object.assign({}, conf, options, {
      url: "" + options.url + (options.url.includes('?') ? '&' : '?') + "platform=" + options.platform,
      debug: forceDebug || !!options.debug
    });
  }

  Report.promisifyRunWebVitals = function promisifyRunWebVitals(fn) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return new Promise(function (resolve) {
      fn.apply(void 0, [function (metric) {
        resolve(metric);
      }].concat(args));
    });
  };

  Report.formatMetric = function formatMetric(_ref) {
    var _ref2;

    var name = _ref.name,
        value = _ref.value;
    return _ref2 = {}, _ref2[name.toLowerCase()] = value === 0 ? 0.001 : +Number(value).toFixed(3), _ref2;
  }
  /**
   * 页面基础的 performance 信息
   * @param pageData
   */
  ;

  var _proto = Report.prototype;

  _proto.reportPageRenderDetail = function reportPageRenderDetail(pageData) {
    try {
      var _this2 = this;

      var timing = window.performance.timing;

      var url = _this2.options.getPageUrl();

      if (!pageData.pageName) return Promise.resolve();

      if (timing.loadEventEnd <= 0) {
        var timer = window.setTimeout(function () {
          window.clearTimeout(timer);

          _this2.reportPageRenderDetail(pageData);
        }, 500);
        return Promise.resolve();
      } // 这里也需要包含 cls lcp


      return Promise.resolve(Promise.all([_this2.getCLS, _this2.getLCP]).then(function (res) {
        return res.reduce(function (pre, curMetric) {
          return _extends({}, pre, Report.formatMetric(curMetric));
        }, {});
      })).then(function (vitalsData) {
        var logObj = {
          timestamp: Date.now(),
          level: 'I',
          is_masked: true,
          message: _extends({
            _domain_: getDomain(),
            _logger_name_: 'access_log:frontend:web',
            _page_: pageData.pageName,
            _url_: url,
            _duration_: timing.loadEventEnd - timing.navigationStart,
            _succ_: true,
            _code_: 200,
            _error_: '',
            network: 'NA',
            upstream: 0,
            downstream: 0,
            // Ref: http://www.alloyteam.com/2020/01/14184/
            redirect_dt: timing.redirectEnd - timing.redirectStart,
            dns_dt: timing.domainLookupEnd - timing.domainLookupStart,
            tcp_dt: timing.connectEnd - timing.connectStart,
            ttfb: timing.responseStart - timing.navigationStart,
            req_dt: timing.responseEnd - timing.requestStart,
            analysis_dt: timing.domInteractive - timing.responseEnd,
            blank_dt: timing.responseEnd - timing.fetchStart,
            domready_dt: timing.domContentLoadedEventEnd - timing.fetchStart,
            firstcp_dt: timing.loadEventStart - timing.fetchStart
          }, vitalsData)
        };

        _this2.reportData(logObj); // @NOTE: 页面加载完成，立即上报，防止漏报

      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.reportData = function reportData(logObj, useQueue) {
    if (useQueue === void 0) {
      useQueue = false;
    }

    Object.assign(logObj.message, this.options.extraMsg);
    report(this.options, logObj, useQueue);
  } // 手动更新扩展msg信息
  ;

  _proto.setExtraMsg = function setExtraMsg(msg) {
    this.options.extraMsg = msg;
  }
  /**
   * 追踪页面核心 cls lcp fid 等指标
   * @param pageData
   */
  ;

  _proto.reportWebVitals = function reportWebVitals(pageData) {
    var _this3 = this;

    // 发送web vitals 数据
    var sendWebVitalsData = function sendWebVitalsData(metric) {
      var data = Report.formatMetric(metric);

      var url = _this3.options.getPageUrl();

      var logObj = {
        timestamp: Date.now(),
        level: 'I',
        is_masked: true,
        message: _extends({
          _domain_: getDomain(),
          _logger_name_: 'access_log:frontend:vitals',
          _page_: pageData.pageName,
          _url_: url,
          _code_: 200
        }, data)
      };

      _this3.reportData(logObj);
    };

    [this.getCLS, this.getFID, this.getLCP].forEach(function (getMetricFn) {
      if (getMetricFn) {
        getMetricFn.then(function (metric) {
          sendWebVitalsData(metric);
        });
      }
    });
  }
  /**
   * 页面基础的 图片加载信息
   * @param options
   */
  ;

  _proto.reportImgLoadTime = function reportImgLoadTime(options) {
    var _this4 = this,
        _performance;

    var pageData = this.options.getPageData();

    var sendImgData = function sendImgData(imgData) {
      var url = _this4.options.getPageUrl();

      var logObj = {
        timestamp: Date.now(),
        level: 'I',
        is_masked: true,
        message: _extends({
          _domain_: getDomain(),
          _logger_name_: 'access_log:frontend:web-image',
          _page_: pageData.pageName,
          _url_: url
        }, imgData)
      };

      _this4.reportData(logObj, true);
    };

    var filterOptions = _extends({
      minSize: 200,
      minDuration: 200,
      custom: function custom() {
        return true;
      }
    }, options ? options.filter : {}); // report entryList


    var reportImgEntryList = function reportImgEntryList(entryList) {
      var filterList = entryList.map(function (item) {
        return item.toJSON();
      }).filter(function (item) {
        // img 或者 css包含png、webp等
        if (!(item.initiatorType === 'img' || item.initiatorType === 'css' && /\.(png|jpe?g|gif|bmp|psd|tiff|tga|eps|webp)$/.test(item.name))) {
          return false;
        }

        if (item.encodedBodySize / 1024 < filterOptions.minSize) {
          return false;
        }

        if (item.duration < filterOptions.minDuration) {
          return false;
        }

        if (filterOptions.custom) {
          return filterOptions.custom(item);
        }

        return true;
      });
      if (!filterList.length) return;
      filterList.forEach(function (item) {
        var data = {
          encodedBodySize: Math.round(item.encodedBodySize / 1024),
          duration: Math.round(item.duration),
          imgUrl: item.name
        };
        sendImgData(data);
      });
    }; // PerformanceObserver ？


    if ((_performance = performance) !== null && _performance !== void 0 && _performance.getEntriesByType && PerformanceObserver) {
      // 立即上报
      reportImgEntryList(performance.getEntriesByType('resource')); // 监听图片资源加载 增量上报

      var observer = new PerformanceObserver(function (list) {
        reportImgEntryList(list.getEntries());
      });
      observer.observe({
        entryTypes: ['resource']
      });
    }
  }
  /**
   * 自动追踪页面性能相关数据
   * @param pageData
   */
  ;

  _proto.reportPerformance = function reportPerformance(pageData) {
    var _this5 = this;

    // 默认pageData
    if (!pageData) pageData = this.options.getPageData();
    if (!isBrowser() || !pageData.pageName) return; // 反复调用不更新值

    if (!this.getCLS) {
      this.getCLS = Report.promisifyRunWebVitals(getCLS);
      this.getLCP = Report.promisifyRunWebVitals(getLCP);
      this.getFID = Report.promisifyRunWebVitals(getFID);
    } // 上报 web vitals


    this.reportWebVitals(pageData); // 旧的performance 信息，onload上报

    onPageLoaded(function () {
      if (pageData) {
        _this5.reportPageRenderDetail(pageData).then(function () {// nothing ...
        });
      }
    });
  }
  /**
   * 追踪请求成功
   * @param pageData
   * @param config axios config
   * @param response axios response
   */
  ;

  _proto.reportRequestSuccess = function reportRequestSuccess(pageData, config, response) {
    var _this6 = this;

    if (!isBrowser()) return;
    if (!pageData) pageData = this.options.getPageData();
    setTimeout(function () {
      try {
        // const [url, query = ''] = config.url.split('?')
        var _config$url$split = config.url.split('?'),
            url = _config$url$split[0];

        var error = response.data && response.data.error || {};
        var logObj = {
          timestamp: Date.now(),
          level: 'I',
          is_masked: true,
          message: {
            _domain_: getDomain(),
            _logger_name_: 'access_log:frontend_http_client',
            _url_: url,
            _page_: pageData.pageName || 'global_page',
            _duration_: Date.now() - config.startTime,
            _succ_: true,
            _code_: error.code || '',
            _error_: error.message || '',
            http_rsp_code: response.status,
            network: 'NA',
            upstream: config.data ? getContentLength(JSON.stringify(config.data)) : 0,
            downstream: getContentLength(JSON.stringify(response.data))
          }
        };

        _this6.reportData(logObj, true);
      } catch (error) {// Ignore
      }
    }, 0);
  }
  /**
   * 追踪请求失败
   * @param pageData
   * @param config axios config
   * @param response axios response
   * @param error Error
   */
  ;

  _proto.reportRequestError = function reportRequestError(pageData, config, response, error) {
    var _this7 = this;

    if (!isBrowser()) return;
    if (!pageData) pageData = this.options.getPageData();
    setTimeout(function () {
      try {
        // const [url, query = ''] = config.url.split('?')
        var _config$url$split2 = config.url.split('?'),
            url = _config$url$split2[0];

        var logObj = {
          timestamp: Date.now(),
          level: 'I',
          is_masked: true,
          message: {
            _domain_: getDomain(),
            _logger_name_: 'access_log:frontend_http_client',
            _url_: url,
            _page_: pageData.pageName || 'global_page',
            _duration_: Date.now() - config.startTime,
            _succ_: false,
            _code_: '',
            _error_: error.message || '',
            http_rsp_code: response && response.status || 400,
            network: 'NA',
            upstream: 0,
            downstream: 0
          }
        };

        _this7.reportData(logObj, true);
      } catch (error) {// Ignore
      }
    }, 0);
  };

  return Report;
}();

export default Report;
//# sourceMappingURL=client-report.esm.js.map
